'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _class3;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BrowserDetection = (0, _mobxReact.observer)(_class = function (_Component) {
  (0, _inherits3.default)(BrowserDetection, _Component);

  function BrowserDetection() {
    (0, _classCallCheck3.default)(this, BrowserDetection);
    return (0, _possibleConstructorReturn3.default)(this, (BrowserDetection.__proto__ || (0, _getPrototypeOf2.default)(BrowserDetection)).apply(this, arguments));
  }

  (0, _createClass3.default)(BrowserDetection, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(BrowserDetectorComponent, { detectionState: this.props.detectionState });
    }
  }]);
  return BrowserDetection;
}(_react.Component)) || _class;

;

var BrowserDetectorComponent = (0, _mobxReact.observer)(_class2 = function (_Component2) {
  (0, _inherits3.default)(BrowserDetectorComponent, _Component2);

  function BrowserDetectorComponent() {
    (0, _classCallCheck3.default)(this, BrowserDetectorComponent);
    return (0, _possibleConstructorReturn3.default)(this, (BrowserDetectorComponent.__proto__ || (0, _getPrototypeOf2.default)(BrowserDetectorComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(BrowserDetectorComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.detectionState.browserClassInjection();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.props.detectionState.confirmed || this.props.detectionState.browserIsSupported() ? 'trc-browser-detection hidden' : 'trc-browser-detection' },
        this.props.detectionState.confirmed === true || this.props.detectionState.browserIsSupported() ? '' : _react2.default.createElement(NotSupportedModal, { detectionState: this.props.detectionState })
      );
    }
  }]);
  return BrowserDetectorComponent;
}(_react.Component)) || _class2;

;

var NotSupportedModal = (0, _mobxReact.observer)(_class3 = function (_Component3) {
  (0, _inherits3.default)(NotSupportedModal, _Component3);

  function NotSupportedModal() {
    (0, _classCallCheck3.default)(this, NotSupportedModal);
    return (0, _possibleConstructorReturn3.default)(this, (NotSupportedModal.__proto__ || (0, _getPrototypeOf2.default)(NotSupportedModal)).apply(this, arguments));
  }

  (0, _createClass3.default)(NotSupportedModal, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        { className: 'table' },
        _react2.default.createElement(
          'div',
          { className: 'cell' },
          _react2.default.createElement(
            'div',
            { className: 'box' },
            _react2.default.createElement(
              'div',
              { className: 'message' },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                'Web Browser Not Supported'
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'div',
                { className: 'browser-details' },
                this.props.detectionState.getCurrentBrowserIcon() !== false ? _react2.default.createElement('span', { className: 'browser-icon fa ' + this.props.detectionState.getCurrentBrowserIcon() }) : '',
                _react2.default.createElement(
                  'span',
                  { className: 'browser-name' },
                  this.props.detectionState.ua.getBrowser().name,
                  ' - '
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'browser-version' },
                  this.props.detectionState.ua.getBrowser().version
                )
              ),
              _react2.default.createElement('div', { className: 'description', dangerouslySetInnerHTML: this.props.detectionState.displayBrowserNotSupportedMessage() })
            ),
            _react2.default.createElement(
              'div',
              { className: 'confirmation' },
              _react2.default.createElement(
                'div',
                { className: 'action', onClick: function onClick(event) {
                    return _this4.props.detectionState.confirm(event);
                  } },
                'Proceed'
              )
            )
          )
        )
      );
    }
  }]);
  return NotSupportedModal;
}(_react.Component)) || _class3;

;

var _default = BrowserDetection;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BrowserDetection, 'BrowserDetection', 'src/core_modules/trc-browser-detection/browser-detection.jsx');

  __REACT_HOT_LOADER__.register(BrowserDetectorComponent, 'BrowserDetectorComponent', 'src/core_modules/trc-browser-detection/browser-detection.jsx');

  __REACT_HOT_LOADER__.register(NotSupportedModal, 'NotSupportedModal', 'src/core_modules/trc-browser-detection/browser-detection.jsx');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/core_modules/trc-browser-detection/browser-detection.jsx');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/trc-browser-detection/browser-detection.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/trc-browser-detection/browser-detection.js
// module chunks = 2